import React, {useEffect} from 'react';
import { useAppDispatch, useAppSelector } from '../../../ducks/hooks';
import { useLocation } from 'react-router'
import { setLayoutState } from '../../../ducks/app'
import classNames from 'classnames'

const LayoutState: React.FC = () => {
  const location = useLocation();
  const layoutState = useAppSelector(state => state.app.layoutState);
  const dispatch = useAppDispatch();

  const getURLLayoutParams = () => {
    const urlSearchParams = new URLSearchParams(location.search.replace('?', ''));
    const urlLayoutParams: Record<string, string> = {};
    for (const [key, value] of urlSearchParams.entries()) {
      urlLayoutParams[key] = value;
    }
    return urlLayoutParams;
  }

  function bootstrapLayoutSettings() {
    const urlParams = getURLLayoutParams();
    const storageParams = JSON.parse(window.localStorage.getItem('app.layoutState') || '{}');
    if (storageParams) {
      delete storageParams.settingsOpened;
    }
    const mergedParams = Object.assign({}, storageParams, urlParams);
    const booleanMergedParams = JSON.parse(
      JSON.stringify(mergedParams),
      (_key, value) => (value === 'true' ? true : value === 'false' ? false : value),
    );
    dispatch(setLayoutState({ ...booleanMergedParams }));
  }

  useEffect(bootstrapLayoutSettings, [dispatch]);
  useEffect(updateBodyClass, [layoutState]);

  function updateBodyClass() {
    document.body.className = classNames(layoutState);
  }

  return null;
}

export default LayoutState;
